<div class="header">
    <div class="header-items">
        <div class="header-item logo-container">
            <a href="#" class="side-nav-toggle hide" (click)="toggleSideNav($event)">
                <mat-icon>menu</mat-icon>
            </a>
            <div class="side-nav-toggle hamburger" [class.is-active]="isMenuOpened">
                <div class="hamburger-box" (click)="toggleSideNav($event)">
                    <div class="hamburger-inner"></div>
                </div>
            </div>
            <upsc-logo></upsc-logo>
        </div>
        <div class="header-item last-item">
            <upsc-user-block [user]="user"></upsc-user-block>
            <upsc-notification-icon [hasItems]="appState.customer$()?.IsPastDue && appState.user$()?.CountryCode?.toUpperCase() === 'US'">
                <div message>
                    <span [innerHtml]="'notifications.message' | translate"></span>
                    <a routerLink="/billing-history">
                        <span [innerHtml]="'notifications.payNow' | translate"></span>
                    </a>
                </div>
            </upsc-notification-icon>
            <upsc-language-selector [availableLanguages]="availableLanguages"
                                    [useLanguage]="currentLanguage"></upsc-language-selector>
        </div>
    </div>
</div>
